export enum GroupError {
	GROUPS_ERROR = 'There was an error loading groups. Please try again.',
	DELETE_ERROR = 'There was an error deleting the group. Please try again.',
	DELETE_MESSAGE_ERROR = 'There was an error deleting the group message. Please try again.',
}

export enum GroupMessage {
	DELETE_GROUP_MESSAGE = 'Are you sure you want to delete?',
	DELETED_GROUP_MESSAGE = 'Group deleted successfully',
	GROUP_MESSAGE_DELETED = 'Message deleted successfully',
}
